export default "__VITE_ASSET__CLNEVvuf__"